import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
export var MatchMachine = /*#__PURE__*/function () {
  /**
   * 规则匹配机
   *
   * 主要用于：
   *   匹配 mimeType，并根据 mimeType 返回 icon;
   *   根据文件扩展名推断 Mimetype;
   *
   * 首先试图根据精准匹配规则寻找匹配结果；若无精准匹配结果则试图寻找模糊匹配结果；若无则返回默认结果
   */
  function MatchMachine(preciseMatchMap, fuzzyMatchRules) {
    _classCallCheck(this, MatchMachine);
    this.preciseMatchMap = preciseMatchMap;
    this.fuzzyMatchRules = fuzzyMatchRules;
  }

  /** 匹配并返回结果 */
  _createClass(MatchMachine, [{
    key: "run",
    value: function run(str) {
      var _Object$keys;
      if (typeof str !== 'string') {
        console.warn('file-icon match with none-string parameter');
        return undefined;
      }
      var transformStr = (_Object$keys = Object.keys(this.preciseMatchMap)) !== null && _Object$keys !== void 0 && (_Object$keys = _Object$keys[0]) !== null && _Object$keys !== void 0 && _Object$keys.includes('/') ? str : str.replace('/', '-');

      /**
       * 由于图片资源是放在cdn上的，并且是以mimeType来命名，名字如果是application/pdf的话，就会把application变成一个文件路径，资源最后是叫pdf.svg。
       * 为了要兼容这个特殊的逻辑，将图片资源的名字改成application-pdf.svg。 
       * 这里单独转换一下 mimeType 中的 '/' -> '-' 来完全匹配
       */
      var mapResult = this.preciseMatchMap[transformStr];
      if (mapResult) {
        return mapResult;
      }

      // 试图根据模糊匹配规则获得匹配结果，若无则返回默认结果
      var matchResult = this.fuzzyMatchRules.find(function (rule) {
        if (rule.mimeTypes) return rule.mimeTypes.includes(str);
        if (rule.reg) return rule.reg.test(str);
      });
      return matchResult === null || matchResult === void 0 ? void 0 : matchResult.result;
    }
  }]);
  return MatchMachine;
}();
//# sourceMappingURL=match-machine.js.map